/* D89-F: phone idea rows and checks; locked text stays server-side, never in this script. */
(function () {
  'use strict';
  function init() {
    var format;
    try {
      format = new Intl.NumberFormat(document.documentElement.lang || undefined);
    } catch (e) {
      format = new Intl.NumberFormat();
    }
    function text(template, n, total) {
      return (template || '').replace(/@N@/g, format.format(n)).replace(/@T@/g, format.format(total));
    }
    document.querySelectorAll('[data-ln19-ki]').forEach(function (root) {
      var track = root.querySelector('.ln19-track');
      if (!track) return;
      var cards = Array.from(track.children);
      var bars = root.querySelectorAll('.ln19-segs i');
      var counter = root.querySelector('[data-ln19-count]');
      var next = root.querySelector('[data-ln19-next]');
      var current = 0, pending = false;
      if (!cards.length) return;
      function horizontal() { return track.scrollWidth > track.clientWidth; }
      function rtl() { return getComputedStyle(track).direction === 'rtl'; }
      function update(i) {
        current = Math.max(0, Math.min(cards.length - 1, i));
        bars.forEach(function (bar, k) { bar.classList.toggle('on', k <= current); });
        if (counter) counter.textContent = text(root.dataset.of, current + 1, cards.length);
        if (next) {
          next.hidden = current === cards.length - 1;
          next.setAttribute('href', '#' + cards[Math.min(current + 1, cards.length - 1)].id);
        }
      }
      function move(i) {
        update(i);
        track.scrollTo({
          left: (rtl() ? -1 : 1) * current * track.clientWidth,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      if (next) next.addEventListener('click', function (event) {
        if (!horizontal()) return;
        event.preventDefault();
        move(current + 1);
      });
      track.addEventListener('scroll', function () {
        if (pending || !horizontal()) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          if (horizontal() && track.clientWidth) update(Math.round(Math.abs(track.scrollLeft) / track.clientWidth));
        });
      });
      track.addEventListener('click', function (event) {
        if (!horizontal() || event.target.closest('a, button, input')) return;
        var rect = track.getBoundingClientRect();
        var back = rtl() ? event.clientX > rect.right - rect.width / 3 : event.clientX < rect.left + rect.width / 3;
        move(current + (back ? -1 : 1));
      });
      track.addEventListener('keydown', function (event) {
        if (!horizontal() || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
        event.preventDefault();
        var forward = event.key === (rtl() ? 'ArrowLeft' : 'ArrowRight');
        move(current + (forward ? 1 : -1));
      });
      window.addEventListener('resize', function () {
        if (horizontal()) move(current);
      });
      update(0);
    });
    document.querySelectorAll('[data-ln19-check]').forEach(function (root) {
      var groups = Array.from(root.querySelectorAll('[data-ln19-q]'));
      var next = root.querySelector('[data-ln19-qnext]');
      var score = root.querySelector('[data-ln19-score]');
      var counter = root.querySelector('[data-ln19-qn]');
      var current = 0, right = 0;
      if (!groups.length) return;
      function show() {
        groups.forEach(function (group, k) { group.hidden = k !== current; });
        if (counter) counter.textContent = text(root.dataset.of, current + 1, groups.length);
        if (next) next.hidden = true;
      }
      groups.forEach(function (group, k) {
        group.addEventListener('change', function (event) {
          var input = event.target;
          if (k !== current || group.classList.contains('ln19-done') || !input.matches('input[type="radio"]')) return;
          group.classList.add('ln19-done');
          var inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
          var labels = group.querySelectorAll('.qz19-o');
          var answer = Number(group.dataset.a);
          var correct = Number(input.value) === answer;
          inputs.forEach(function (item) { item.disabled = true; });
          if (labels[answer]) labels[answer].classList.add('on', 'ln19-good');
          if (!correct) {
            var chosen = input.closest('label');
            if (chosen) {
              chosen.classList.remove('on');
              chosen.classList.add('ln19-bad');
            }
          } else right++;
          var reply = group.querySelector('.qz19-reply');
          if (reply) {
            reply.hidden = false;
            var ok = reply.querySelector('[data-ok]');
            var no = reply.querySelector('[data-no]');
            if (ok) ok.hidden = !correct;
            if (no) no.hidden = correct;
          }
          if (current < groups.length - 1) {
            if (next) next.hidden = false;
          } else {
            if (next) next.hidden = true;
            if (score) {
              score.textContent = text(root.dataset.score, right, groups.length);
              score.hidden = false;
            }
          }
        });
      });
      if (next) next.addEventListener('click', function () {
        if (!groups[current].classList.contains('ln19-done') || current >= groups.length - 1) return;
        current++;
        show();
        var heading = groups[current].querySelector('h3.ln19-q');
        if (heading) heading.focus();
      });
      show();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
